// Select-all for a bulk decision, with the guardrail in front of the button instead of in the
// error afterwards. A registration only moves to `selected` from certain states; the server
// enforces that, but an admin who ticks every row and presses Approve should be told, before
// pressing, how many of their selection will actually move.
//
// The count is rendered server-side into the note, so the page is correct before this runs and
// without JavaScript the checkboxes are simply individual.
export function initBulkPick(root = document) {
  const all = root.querySelector('[data-pick-all]');
  const note = root.querySelector('[data-pick-note]');
  if (!all || !note) return;
  const boxes = () => [...root.querySelectorAll('input[name="registration_id"]')];
  const strings = (() => {
    try {
      return JSON.parse(root.getElementById('bulk-pick-strings')?.textContent || '{}');
    } catch {
      return {};
    }
  })();
  const say = (key, vars) =>
    String(strings[key] ?? '').replace(/\{\{(\w+)\}\}/g, (_, n) => vars[n] ?? '');

  function update() {
    const picked = boxes().filter((b) => b.checked);
    const movable = picked.filter((b) => b.dataset.canApprove === '1');
    const approve = root.querySelector('[data-approve]');
    if (approve) approve.disabled = picked.length > 0 && movable.length === 0;
    note.textContent = !picked.length
      ? say('none', {})
      : movable.length === picked.length
        ? say('all', { n: picked.length })
        : say('some', { n: movable.length, total: picked.length });
    note.classList.toggle(
      'text-warning-emphasis',
      picked.length > 0 && movable.length < picked.length
    );
    const eligible = boxes().filter((b) => b.dataset.canApprove === '1');
    all.checked = eligible.length > 0 && eligible.every((b) => b.checked);
    all.indeterminate = !all.checked && picked.length > 0;
  }

  // Select-all ticks only the rows an approval can move. Ticking rows that cannot move would
  // make the button look like it does more than it does.
  all.addEventListener('change', () => {
    for (const box of boxes()) box.checked = all.checked && box.dataset.canApprove === '1';
    update();
  });
  root.addEventListener('change', (event) => {
    if (event.target.matches('input[name="registration_id"]')) update();
  });
  update();
}
